export default function Manifesto() {
  return (
    <main className="max-w-3xl mx-auto px-6 sm:px-10 py-16 sm:py-24">
      <p className="label-overline text-center">A small middle finger to TPTB</p>
      <h1 className="font-display text-5xl sm:text-6xl text-center mt-3">The Manifesto</h1>
      <div className="fleuron my-10">❦ ❦ ❦</div>

      <article className="space-y-7 font-body text-lg leading-relaxed text-ink-iron">
        <p className="drop-cap">
          In the 18th century, the very wealthy of England and the colonies engaged in an
          extraordinary kind of theatre: they hired an ornamental hermit. A real human soul,
          dressed in a long beard and a brown cloak, paid in modest coin and a roof, to wander
          the estate and seem profound. The hermits cared for animals. They tended gardens.
          Some never spoke. Some befriended foxes. The contract was the contract.
        </p>

        <p>
          We do not write this manifesto to praise the practice in full. We write it because
          something in it deserves remembering: the simple, unbothered exchange of a roof for a
          presence. Housing as a quiet kindness rather than a quarterly extraction.
        </p>

        <p className="marginalia">
          “Some were seen but never heard; some heard but never seen.” — a footnote, from a 1772 estate ledger.
        </p>

        <p>
          The world has changed. Rents have not gone down. Corporate titans have purchased entire
          neighbourhoods to lease back at a premium. The hermitage was, in its odd 18th-century way,
          an alternative to all this — a freely-given roof in exchange for company, custodianship,
          and the patience to be alone in someone else's woods.
        </p>

        <p>
          <em>Hearth &amp; Hermit</em> is not for everyone. It will not solve the housing crisis.
          It will not make landlords kind. But for those true hermits — readers, walkers, gardeners,
          recluses of every variety — and the land owners who appreciate a solitary presence on their
          property, this is a small portal to an arrangement that predates all of this.
        </p>

        <p>
          We are based in the United States and the United Kingdom. We accept letters from elsewhere.
          We honour contracts. We respect solitude. We expect honesty.
        </p>

        <p className="font-display italic text-3xl text-wax-red pt-4">Let the hermitage begin.</p>
      </article>
    </main>
  );
}
